<template lang="pug">
.help_modal
  a.question(v-if='!link')
    .icon(@click='open'): v-icon(name='regular/question-circle')
  a(v-if='link' @click='open') {{ link }}
  .modal.animated.faster.fadeIn.is-active(v-show='active')
    .modal-background(@click='close')
    .modal-content
      slot
    button.modal-close.is-large(aria-label='close' @click='close')

</template>
<script>
import 'vue-awesome/icons/regular/question-circle'

export default {
  name: 'help_modal',
  data() { return {
    active: false
  }},
  props: ['link'],
  methods: {
    open() {
      this.active = true
      this.$nextTick(() => {
        $(this.$el).find('.modal').appendTo('body')
      })
    },
    close() { this.active = false }
  }
}
</script>

<style lang="sass">
.help_modal
  display: inline-block
  .question
    color: green
    opacity: 0.6
    &:hover
      opacity: 1
</style>
